jQuery(document).ready(function ($) {

  $('.mobile-menu-toggle').click(function () {
    $('.mobile-menu').toggleClass('show');
    $(this).toggleClass('active');
  });

  $('.mobile-menu a').click(function (e) {
    if ($(this).attr('href') === '#') {
        e.preventDefault();
        $(this).css('pointer-events', 'none');
    } else {
        $('.mobile-menu').removeClass('show');
        $('.mobile-menu-toggle').removeClass('active');
    }
  });

  function addCaret() {
    if ($(window).width() <= 1200) {
      $('.menu-item-has-children').each(function() {
        if ($(this).find('.thereCaret').length === 0) {
          $(this).append('<span class="thereCaret"></span>');
        }
      });
    } else {
      $('.menu-item-has-children .thereCaret').remove();
    }
  }
  function toggleSubMenu() {
    $(document).on('click', '.thereCaret', function(e) {
      e.preventDefault(); 
      let $parent = $(this).closest('.menu-item-has-children');
      let $subMenu = $parent.find('.sub-menu').first();
      
      $(this).toggleClass('active');
      $subMenu.toggleClass('openMenu');
      $subMenu.stop(true, true).slideToggle(300);
    });
  }

  addCaret();
  toggleSubMenu()

  $(window).resize(function() {
    addCaret();
  });


  function isElementVisible(elem) {
    const docViewTop = $(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();
    const elemTop = $(elem).offset().top;
    const elemBottom = elemTop + $(elem).height();
    return ((elemBottom <= docViewBottom - 20) && (elemTop >= docViewTop + 20));
  }

  function animateNumber($element) {
    const originalValue = parseFloat($element.data('original-value'));
    $({ Counter: 0 }).animate({ Counter: originalValue }, {
      duration: 1500,
      easing: 'swing',
      step: function (now) {
        const decimalLength = originalValue.toString().includes('.') ? originalValue.toString().split('.')[1].length : 0;
        $element.text(now.toFixed(decimalLength));
      },
      complete: function () {
        $element.addClass('animated');
      }
    });
  }

  function checkAndAnimateNumbers() {
    $('.number-animation .number').each(function () {
      const $this = $(this);
      if (isElementVisible($this) && !$this.hasClass('animated')) {
        $this.addClass('animated');
        animateNumber($this);
      }
    });
  }

  $('.number-animation .number').each(function () {
    const originalValue = parseFloat($(this).text().trim());
    $(this).data('original-value', originalValue).text(0);
  });

  $(window).scroll(checkAndAnimateNumbers);

  $(document).ready(checkAndAnimateNumbers);

  // Home banner slik slidew
  if ($('.home-banner-slider').length) {
    $('.home-banner-slider').each(function() {
        let swiper = new Swiper('.home-banner-slider', {
            loop: true,
            effect: "fade",
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 8000,
            },
        });
    });
  }

  // Start video (wrapper with .rem-video)
  $('.rem-video').on('click', function() {
    const video = $(this).find('video');
    video.attr('controls', true);

    video[0].play();
    $(this).addClass('video-playing');
  });

  // [video_play_button] shortcode — play sibling / block video
  $(document).on('click', '.js-video-play-shortcode-btn', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const dataSel = $btn.attr('data-target-selector');
    let $video = $();

    if (dataSel) {
      const $target = $(dataSel).first();
      $video = $target.is('video') ? $target : $target.find('video').first();
    }

    if (!$video.length) {
      $video = $btn.prevAll('figure.wp-block-video').first().find('video');
    }
    if (!$video.length) {
      $video = $btn.nextAll('figure.wp-block-video').first().find('video');
    }
    if (!$video.length) {
      $video = $btn.closest('.gb-inside-container, .gb-container, .post-content, article, main').find('video').first();
    }

    const videoEl = $video.get(0);
    if (!videoEl) {
      return;
    }

    $video.attr('controls', true);
    const playPromise = videoEl.play();
    if (playPromise !== undefined) {
      playPromise.catch(function () {});
    }

    $btn.closest('.gb-container').addClass('video-playing');
  });

  // FAQ open content
  $('.faq-title').each(function() {
      $(this).parent().addClass('faq-item');
  });

  $('.faq-title').on('click', function() {
      $(this).toggleClass('active');
      $(this).parent().find('.faq-content').slideToggle(300);
  });
  
// Scroll to element with delay
function offsetAnchor() {
  const hash = location.hash;

    if (hash && $(hash).length) {
        $('html, body').stop(true).animate({
            scrollTop: $(hash).offset().top - 170
        }, 400); 
    }
  }

  if (location.hash) {
    $('html, body').scrollTop(0);
    setTimeout(function() {
        offsetAnchor();
    }, 200); 
  }

  $(window).on('hashchange', function() {
    offsetAnchor();
  });

  (function initTocListScrollSpy() {
    const OFFSET = 200;

    function hrefToId(href) {
      if (!href || href.charAt(0) !== '#') {
        return null;
      }
      try {
        return decodeURIComponent(href.slice(1));
      } catch (e) {
        return href.slice(1);
      }
    }

    function collectSections($links) {
      const sections = [];
      const seen = {};
      $links.each(function () {
        const id = hrefToId(this.getAttribute('href'));
        if (!id || seen[id]) {
          return;
        }
        const el = document.getElementById(id);
        if (!el) {
          return;
        }
        seen[id] = true;
        sections.push({ id: id, el: el });
      });
      sections.sort(function (a, b) {
        return a.el.offsetTop - b.el.offsetTop;
      });
      return sections;
    }

    function refreshTocActive() {
      const $links = $('.toc-list a[href^="#"], .link-item a[href^="#"]');
      if (!$links.length) {
        return;
      }
      const sections = collectSections($links);
      if (!sections.length) {
        return;
      }
      let activeId = null;
      for (let i = 0; i < sections.length; i++) {
        if (sections[i].el.getBoundingClientRect().top <= OFFSET) {
          activeId = sections[i].id;
        }
      }
      $links.removeClass('is-active').each(function () {
        const id = hrefToId(this.getAttribute('href'));
        if (activeId !== null && id === activeId) {
          $(this).addClass('is-active');
        }
      });
    }

    $(window).on('scroll.tocList resize.tocList', refreshTocActive);
    refreshTocActive();
  })();

  // Append close button to modal container
  $('.rem-modal').each(function() {
    $(this).find('.gb-inside-container').append('<div class="close-btn"></div>');
  });
  $('.rem-modal .gb-inside-container').each(function() {
      $(this).wrapInner('<div class="modal-inner"></div>');
  });

  // Handle modal open when clicking on rem-modal-btn
  $('.rem-modal-btn').on('click', function(e) {
    const dataId = $(this).attr('data-id');
    
    if ($(`.rem-modal[data-id="${dataId}"]`).length) {
        $(`.rem-modal[data-id="${dataId}"]`).addClass('show');
        jQuery('body').addClass('no-scroll').css('overflow', 'hidden');
    }
    
    e.preventDefault();
  });

  // Handle modal close actions
  $('.rem-modal').on('click', function(e) {
    const modalContainer = $(this).find('.gb-inside-container')[0];

    if ($(e.target).hasClass('close-btn') || !modalContainer.contains(e.target)) {
        $(this).removeClass('show');
        jQuery('body').removeClass('no-scroll').css('overflow', '');
    }

    $(this).find('video').each(function() {
      this.pause();
      this.currentTime = 0;
    });

    $(this).find('iframe').each(function() {
      let src = jQuery(this).attr('src');
      jQuery(this).attr('src', src);
    });
  });

    // pardot iframe auto height
    if ( jQuery('#pardot-iframe').length ) {
      jQuery('#pardot-iframe').seamless({
        fallbackText: ''
      });
    }
    

  // Table 
  function updateTables() {

    const $tables = jQuery('.features-table');
  
    if (!$tables.length) {
      return;
    }
  
    $tables.each(function () {
  
      const $table = jQuery(this);
      $table.removeClass('wp-block-table');
  
      $table.find('thead th').each(function (index) {
  
        const $th = jQuery(this);
        const headerText = jQuery.trim($th.text());
        const imgSrc = $th.find('img').attr('src');
  
        $table.find('tbody tr').each(function () {
  
          const $td = jQuery(this).find('td').eq(index);
  
          if (!$td.length) {
            return;
          }
  
          if (imgSrc) {
            const $img = jQuery('<img>', {
              src: imgSrc,
              alt: ''
            });
  
            const $imgSpan = jQuery('<span>', {
              class: 'img-span'
            }).append($img);
  
            $td.prepend($imgSpan);
          } else {
            const $textSpan = jQuery('<span>', {
              class: 'header-span',
              text: headerText
            });
  
            $td.prepend($textSpan);
          }
  
        });
  
      });
  
    });
  
  }

  updateTables();


  jQuery('.icon-play, .icon-play--white').on('click', function () {
    jQuery(this).removeClass('icon-play icon-play--white ats-gradient');
    let video = jQuery(this).find('video')[0];
    if (video) {
      video.setAttribute('controls', 'controls');
    }
  });

  // case study sidebar
  jQuery(document).on( "scroll", function() {
    if (jQuery('.case-study-content-wrp').length ) {
      jQuery('.case-study-content-wrp .section-title').each(function(i) {

        if (jQuery(document).scrollTop() > ( jQuery(this).offset().top - 170 ) ) {
          var data_title = jQuery(this).attr('data-title');
          jQuery('.case-study-sidebar .sidebar-item').removeClass('active');

          jQuery('.case-study-sidebar .sidebar-item[data-title="' + data_title + '"]').addClass('active');
          
        }
      });
    }
  });

  jQuery('.case-study-sidebar .sidebar-item').click(function() {
    var data_title = jQuery(this).attr('data-title');

    jQuery('.case-study-content-wrp .section-title').each(function() {
      if ( data_title == jQuery(this).attr('data-title') ) {
        jQuery('html, body').animate({
          scrollTop: jQuery(this).offset().top - 150
        }, 500);
      }
    });
  });

  // Open modal
  jQuery(document).on('click', '.open-modal', function(e) {
    e.preventDefault();

    let target = jQuery(this).data('modal');
    if (!target) return;

    let modal = jQuery('.modal-block[data-modal="' + target + '"]');

    if (modal.length) {
      modal.addClass('show');
      jQuery('body').addClass('no-scroll').css('overflow', 'hidden');
    }
  });


if ($('.testimonial-slider').length) {

  // Add swiper classes
  $('.testimonial-slider')
      .addClass('swiper')
      .wrapInner('<div class="swiper-wrapper"></div>');

  // Convert each column into a slide
  $('.testimonial-slider .gb-grid-column').each(function() {
      $(this).addClass('swiper-slide');
  });

  // Add pagination + arrows
  $('.testimonial-slider').append('<div class="swiper-button-prev"></div>');
  $('.testimonial-slider').append('<div class="swiper-button-next"></div>');
 

  // Init Swiper
  new Swiper('.testimonial-slider', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
          nextEl: '.testimonial-slider .swiper-button-next',
          prevEl: '.testimonial-slider .swiper-button-prev',
      },
  });
}


$('.slider-blocks').each(function () {

  const slider = $(this);
  const sliderId = slider.attr('data-id');

  const controls = $('.gb-button-wrapper[data-target="' + sliderId + '"]');

  const nextBtn = controls.find('.slider-next')[0];
  const prevBtn = controls.find('.slider-prev')[0];

  slider.addClass('swiper');
  slider.wrapInner('<div class="swiper-wrapper"></div>');
  slider.find('.gb-grid-column').addClass('swiper-slide');

  new Swiper(slider[0], {
      slidesPerView: 3.2,
      spaceBetween: 0,
      loop: true,
      navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
      },
      breakpoints: {
          0: {
              slidesPerView: 1
          },
          480: {
              slidesPerView: 2
          },
          768: {
              slidesPerView: 3.2
          }
      }
  });

});

function appendUTMParametersToInternalLinks() {
  const currentUrl = new URL(document.URL);
  const currentOrigin = currentUrl.origin;
  const pageParams = currentUrl.searchParams;
  const utmEntries = [];
  const sanitizeUtmValue = function (value) {
    return String(value).replace(/[^\w\- .~%+]/g, '').trim().slice(0, 200);
  };

  pageParams.forEach(function (value, key) {
    if (key.toLowerCase().startsWith('utm_')) {
      const safeValue = sanitizeUtmValue(value);
      if (safeValue) {
        utmEntries.push([key, safeValue]);
      }
    }
  });

  if (!utmEntries.length) return;

  $('a[href]').each(function () {
    const $el = $(this);
    const href = $el.attr('href');

    if (!href || href.startsWith('#') || href.toLowerCase().startsWith('javascript:')) return;
    if (/^(mailto:|tel:)/i.test(href)) return;

    let parsedUrl;

    try {
      parsedUrl = new URL(href, currentOrigin);
    } catch (error) {
      return;
    }

    if (parsedUrl.origin !== currentOrigin) return;

    utmEntries.forEach(function (entry) {
      const key = entry[0];
      const value = entry[1];
      if (!parsedUrl.searchParams.has(key)) {
        parsedUrl.searchParams.set(key, value);
      }
    });

    const isAbsolute = /^https?:\/\//i.test(href);
    const updatedHref = isAbsolute
      ? parsedUrl.toString()
      : parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;

    $el.attr('href', updatedHref);
  });
}

appendUTMParametersToInternalLinks();

});

